<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-0.75 -0.75 24 24"
    height="24"
    width="24"
  >
    <path
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M18.984375 3.515625v15.46875l0.5549999999999999 0.7771874999999999A1.4071874999999998 1.4071874999999998 0 0 1 18.28125 21.796875h-14.0625a1.40625 1.40625 0 0 1 -1.2581250000000002 -2.0353125l0.5549999999999999 -0.7771874999999999V3.515625l-0.5549999999999999 -0.7771874999999999A1.40625 1.40625 0 0 1 4.21875 0.703125h14.0625a1.40625 1.40625 0 0 1 1.2581250000000002 2.0353125l-0.5549999999999999 0.7771874999999999Z"
      stroke-width="1.5"
    ></path>
    <path
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M14.765625 8.4375h-7.03125"
      stroke-width="1.5"
    ></path>
    <path
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M13.359375 8.4375v8.4375a2.109375 2.109375 0 0 1 -4.21875 0V8.4375"
      stroke-width="1.5"
    ></path>
    <path
      stroke="#000000"
      d="M8.7890625 4.21875a0.3515625 0.3515625 0 1 1 0 -0.703125"
      stroke-width="1.5"
    ></path>
    <path
      stroke="#000000"
      d="M8.7890625 4.21875a0.3515625 0.3515625 0 1 0 0 -0.703125"
      stroke-width="1.5"
    ></path>
    <path
      stroke="#000000"
      d="M12.3046875 6.328125a0.3515625 0.3515625 0 0 1 0 -0.703125"
      stroke-width="1.5"
    ></path>
    <path
      stroke="#000000"
      d="M12.3046875 6.328125a0.3515625 0.3515625 0 0 0 0 -0.703125"
      stroke-width="1.5"
    ></path>
    <path
      stroke="#000000"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M9.140625 11.953125h4.21875"
      stroke-width="1.5"
    ></path>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>